import { render, staticRenderFns } from "./intelligentMain.vue?vue&type=template&id=ec6bfeaa&scoped=true"
import script from "./intelligentMain.vue?vue&type=script&lang=js"
export * from "./intelligentMain.vue?vue&type=script&lang=js"
import style0 from "./intelligentMain.vue?vue&type=style&index=0&id=ec6bfeaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6bfeaa",
  null
  
)

export default component.exports